import { UserTable } from "@/components/user/UserTable";
import { FileQuestion } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { SystemUser, useUserManagement } from "../hooks/useUserManagement";

interface UserTabsProps {
  onViewProfile: (user: SystemUser) => void;
  onEditUser: (user: SystemUser) => void;
  onResetPassword: (user: SystemUser) => void;
}

export function UserTabs({
  onViewProfile,
  onEditUser,
  onResetPassword
}: UserTabsProps) {
  const { users, isLoading } = useUserManagement();

  // Loading state
  if (isLoading && users.length === 0) {
    return (
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-10 w-32" />
        </div>
        <div className="space-y-3">
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </div>
      </div>
    );
  }

  // Empty state
  if (users.length === 0 && !isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <FileQuestion className="h-20 w-20 text-muted-foreground/60 mb-6" />
        <h3 className="text-xl font-semibold mb-3">No users found</h3>
        <p className="text-muted-foreground mb-8 max-w-md leading-relaxed">
          No users have been configured for this company yet. Contact your system administrator to add user accounts.
        </p>
      </div>
    );
  }

  // Main content with users
  return (
    <div className="space-y-6">
      {/* Users Table */}
      <UserTable
        users={users}
        viewUserProfile={onViewProfile}
        onEditUser={onEditUser}
        onResetPassword={onResetPassword}
      />


    </div>
  );
} 